export function plural(num: number, word: string | ((num: number) => string)) {
  const pluralWord =
    typeof word === "string" ? (num === 1 ? word : word + "s") : word(num);

  return `${num} ${pluralWord}`;
}
